import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { INCOME_AND_EMPLOYMENT_ACTION_TYPE } from '../actions';

const initialState = {};

const incomesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case INCOME_AND_EMPLOYMENT_ACTION_TYPE.GET_INCOMES:
        return payload || initialState;

      case INCOME_AND_EMPLOYMENT_ACTION_TYPE.DELETE_LOAN_APPLICATION_INCOME:
        delete draft[meta.incomeId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default incomesReducer;
